<template>
  <ViewTopNav :heading="this.viewType" :subheading="this.assetType" />
  
  <div class="position-absolute p-content z-1">
			<div class="col-12 p-0 z-1 h-100">
				<div class="row g-0 h-100">

          <div class="col-12 col-md-6 col-lg-4 m-auto" v-for="asset in assetTypes" :key="asset.guid">
						<div class="row g-0">
							<div class="col-12 position-relative z-1">

                <!-- Videos -->
                <router-link
                  v-if="viewType === 'videos' && collectionId"
                  :to="{
                    name:  'VideoView',
                    params: {
                      guid: asset.guid,
                      collectionId: asset.videoLibraryId
                    }
                  }"
                  class="v-link"
                >
                  <img :src="theme.streamCdnUrl + '/' + asset.guid + '/' + asset.thumbnailFileName + '?width=700'" class="img-fluid">
                  <div class="render-name">
										{{ asset.title }}
									</div>
                </router-link>

                <!-- Renders -->
                <router-link
                  v-if="viewType === 'renders'"
                  :to="{
                    name:  'AssetViewDetail',
                    params: {
                      assetType: this.assetType,
                      viewType: this.viewType,
                      order: asset.id
                    }
                  }"
                  class="r-link"
                >
                  <img :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'" class="img-fluid">
                  <div class="render-name">
										{{ asset.title }}
									</div>
                </router-link>

                <!-- Panoramas -->
                <router-link
                  v-if="viewType === 'panoramas' || viewType === 'virtual-tour'"
                  :to="{
                    name:  'AssetViewDetail',
                    params: {
                      assetType: this.assetType,
                      viewType: this.viewType,
                      order: asset.id
                    }
                  }"
                  class="p-link"
                >
                  <img :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'" class="img-fluid">
                  <div class="render-name">
										{{ asset.title }}
									</div>
                </router-link>

                <!-- Floorplans -->
                <router-link
                  v-if="viewType === 'floorplans' || viewType === 'brochures'"
                  :to="{
                    name:  'AssetViewDetail',
                    params: {
                      assetType: this.assetType,
                      viewType: this.viewType,
                      order: asset.id
                    }
                  }"
                  class="f-link"
                >
                  <img :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'" class="img-fluid">
                  <div class="render-name">
										{{ asset.title }}
									</div>
                </router-link>

							</div>
						</div>
					</div>
          
      </div>
    </div>
  </div>
  
  <ViewBotNav />
  <OffCanvas />
</template>

<script>
import ViewTopNav from '@/components/ViewTopNav.vue'
import ViewBotNav from '@/components/ViewBotNav.vue'
import OffCanvas from "@/components/OffCanvas.vue";
import global from '../global'
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetView",
  props: [
    'assetType',
    'viewType',
    'lid',
    'collectionId'
  ],
  components: {
    ViewTopNav,
    ViewBotNav,
    OffCanvas
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/' + this.assetType + '/' + this.viewType + '/'),
      videoStatus: false,
      videoNames: null,
      assetNames: null,
    }
  },
  created() {
    if (this.assetType === 'introduction') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.introductionAsset.videos
        this.assetNames = this.theme.introductionAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.introductionAsset.renders
        this.assetNames = this.theme.introductionAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.introductionAsset.panoramas
        this.assetNames = this.theme.introductionAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.introductionAsset.floorplans
        this.assetNames = this.theme.introductionAsset.floorplansName
      } else if (this.viewType === 'brochures') {
        this.assetOrder = this.theme.introductionAsset.brochures
        this.assetNames = this.theme.introductionAsset.brochuresName
      }
    } else if (this.assetType === 'penthouse') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.penthouseAsset.videos
        this.assetNames = this.theme.penthouseAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.penthouseAsset.renders
        this.assetNames = this.theme.penthouseAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.penthouseAsset.panoramas
        this.assetNames = this.theme.penthouseAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.penthouseAsset.floorplans
        this.assetNames = this.theme.penthouseAsset.floorplansName
      }
    } else if (this.assetType === 'sub-penthouse') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.subPenthouseAsset.videos
        this.assetNames = this.theme.subPenthouseAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.subPenthouseAsset.renders
        this.assetNames = this.theme.subPenthouseAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.subPenthouseAsset.panoramas
        this.assetNames = this.theme.subPenthouseAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.subPenthouseAsset.floorplans
        this.assetNames = this.theme.subPenthouseAsset.floorplansName
      }
    } else if (this.assetType === '3-bed-apartment-type-k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.bed3TypeKAsset.videos
        this.assetNames = this.theme.bed3TypeKAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.bed3TypeKAsset.renders
        this.assetNames = this.theme.bed3TypeKAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.bed3TypeKAsset.panoramas
        this.assetNames = this.theme.bed3TypeKAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.bed3TypeKAsset.floorplans
        this.assetNames = this.theme.bed3TypeKAsset.floorplansName
      }
    } else if (this.assetType === '3-bed-apartment-type-l') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.bed3TypeLAsset.videos
        this.assetNames = this.theme.bed3TypeLAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.bed3TypeLAsset.renders
        this.assetNames = this.theme.bed3TypeLAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.bed3TypeLAsset.panoramas
        this.assetNames = this.theme.bed3TypeLAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.bed3TypeLAsset.floorplans
        this.assetNames = this.theme.bed3TypeLAsset.floorplansName
      }
    } else if (this.assetType === '2-bed-apartment') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.bed2Asset.videos
        this.assetNames = this.theme.bed2Asset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.bed2Asset.renders
        this.assetNames = this.theme.bed2Asset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.bed2Asset.panoramas
        this.assetNames = this.theme.bed2Asset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.bed2Asset.floorplans
        this.assetNames = this.theme.bed2Asset.floorplansName
      }
    } else if (this.assetType === 'amenities') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.amenitiesAsset.videos
        this.assetNames = this.theme.amenitiesAsset.videosName
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.amenitiesAsset.renders
        this.assetNames = this.theme.amenitiesAsset.rendersName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.amenitiesAsset.panoramas
        this.assetNames = this.theme.amenitiesAsset.panoramasName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.amenitiesAsset.floorplans
        this.assetNames = this.theme.amenitiesAsset.floorplansName
      }
    }

    // Video type
    if(this.viewType === 'videos') {
      BunnyNetService.getVideos(this.lid, this.collectionId)
      .then(response => {
        // Remap array (inject asset names)
        let j = 0;
        const menuItems = response.data.items.map((item) => {
          return {
            guid: item.guid,
            videoLibraryId: item.videoLibraryId,
            thumbnailFileName: item.thumbnailFileName,
            ObjectName: item.ObjectName,
            title: this.assetNames[j],
            id: j++
          };
        });

        // Custom order array
        if ( this.assetOrder ) {
          this.assetTypes = this.reorder(menuItems, this.assetOrder);
        } else {
          this.assetTypes = menuItems;
        }

        this.videoStatus = true
      })
      .catch(error => {
        console.log(error)
      })
    // Renders, Panoramas, Floorplans type
    } else {
      BunnyNetService.getRenders(this.folderStructure, this.assetType)
      .then(response => {
        let j = 0;
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: this.assetNames[j],
            id: j++
          };
        });

        // Custom order array
        if( this.assetOrder ) {
          this.assetTypes = this.reorder(menuItems, this.assetOrder);
        } else {
          this.assetTypes = menuItems
        }
      })
    }
  },
  methods: {
    reorder: function(data_array, real_order) {
      var i, d = {}, result = [];
      for(i=0; i<data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for(i=0; i<real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    }
  },
  setup () {
    const {theme} = global

    return {
      theme
    }
  }
}
</script>
